'use strict';
import JWT from './JWT';

const getUID = (token) => {

    let decoded = JWT.decode(token);
    if (!decoded) {
        return false
    }

    return decoded.UUID;
}

export default getUID;